'use strict';

import React from 'react';
import { OnSchedUtils } from '../../../utils';


const ListSearch = ({ element, searchTerm, setSearch }) => {
  return (
    <input
      autoFocus
      type='text'
      autoComplete='off'
      style={{width: 'calc(100% - 20px)', margin: '10px 0'}}
      className='FormInput stretch onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover onsched-primary-border-color-active onsched-primary-border-color-focus'
      placeholder={OnSchedUtils.Internationalize(element, `consumer_search_${element.type}`)}
      value={searchTerm}
      onChange={(e) => setSearch(e.target.value)}
    />
  )
}

export default ListSearch
